module.exports = __webpack_public_path__ + "static/media/discover.054b3756.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment-methods/discover.png
// module id = 578
// module chunks = 0